module.exports = __webpack_public_path__ + "img/check-square-green.7b0fc18a.svg";